import React from "react";
import { useCompetition } from "@/context/CompetitionContext";
import { Calendar } from "lucide-react";

export default function CompetitionSelector({ hideEmpty = false }) {
  const { competitions, currentId, setCurrent } = useCompetition();
  if (!competitions?.length) {
    if (hideEmpty) return null;
    return (
      <div className="text-sm text-[var(--text-secondary)]">
        Nenhuma competição cadastrada
      </div>
    );
  }
  return (
    <div className="flex items-center gap-3 max-w-full min-w-0">
      <Calendar size={16} className="text-[#C9A84C] shrink-0" />
      <select
        data-testid="competition-selector"
        className="select-field min-w-0 flex-1"
        value={currentId || ""}
        onChange={(e) => setCurrent(e.target.value)}
      >
        {competitions.map((c) => (
          <option key={c.id} value={c.id}>
            {`${c.nome} — ${c.data}`}
          </option>
        ))}
      </select>
    </div>
  );
}
